import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import createStyles from '@material-ui/core/styles/createStyles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FieldText from '@eduzz/houston-ui/Forms/Text';
import DoneIcon from '@material-ui/icons/Done';
import ContentCopyIcon from 'mdi-react/ContentCopyIcon';
import Button from '@material-ui/core/Button';

interface IProps {
  isOpen: boolean;
  setIsOpen: any;
  shareLink: string;
}

const useStyles = makeStyles((theme) => {
  return createStyles({
    dialog: {
      minWidth: 530,
      '@media (max-width: 660px)': {
        minWidth: 300,
      },
    },
    input: {
      [`& div > input`]: {
        color: 'grey',
        borderRadius: '3px',
        paddingLeft: 10,
      },
      '& .Mui-disabled': {
        background: 'none',
        color: 'grey',
      },
    },
    inputOutline: {
      borderColor: 'gray !important',
    },

    title: {
      backgroundColor: 'rgba(236, 239, 241, 1)',
      color: theme.defaultTheme.gray_palette.dark1,
      '& > h2': {
        fontSize: 16,
        fontWeight: 600,
      },
    },
    titleContent: {
      marginTop: 10,
      color: theme.defaultTheme.gray_palette.dark1,
      lineHeight: 1.5,
      '& > h2': {
        fontSize: 16,
        fontWeight: 600,
      },
    },
    btnAcceptAll: {
      backgroundColor: 'rgba(0, 0, 0, 0.26)',
      height: 40,
      color: theme.defaultTheme.support_palette.white,
      padding: 10,
      '& > svg': {
        width: 20,
        height: 20,
        fill: theme.defaultTheme.support_palette.white,
      },
      '&:focus': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      },
      '&:hover': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      },
      '&:active': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      }
    },
    btnDisabled: {
      outline: 'none',
      backgroundColor: theme.defaultTheme.support_palette.green,
      color: theme.defaultTheme.support_palette.white,
      cursor: 'default',
      pointerEvents: 'none',
      '&:focus': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      },
    },
    closeDialog: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 34,
      '& > button > span': {
        fontSize: 14,
        textTransform: 'capitalize',
        fontWeight: 700,
      },
    },
    btnClose: {
      backgroundColor: 'transparent',
      color: theme.defaultTheme.gray_palette.dark1,
      marginRight: 10,
    },
  });
});

const ShareModal = (props: IProps) => {
  const { isOpen, setIsOpen, shareLink } = props;
  const [ linkCopy, setLinkCopy ] = useState(false);

  const classes = useStyles();

  const copyLink = () => {
    navigator.clipboard.writeText(shareLink);
    setLinkCopy(true);
  }

  const closeDialog = () => {
    setIsOpen(false);
    setLinkCopy(false);
  };

  return (
    <Dialog classes={{ paper: classes.dialog }} open={isOpen}>
      <DialogTitle className={classes.title}>Compartilhar link do curso</DialogTitle>
      <DialogContent>
        <div className={classes.titleContent}>
        <FieldText
          fullWidth
          type='text'
          name='Link'
          label='Link'
          value={shareLink}
          disabled
          className={classes.input}
          InputProps={{
            disableUnderline: true,
            classes: {
              notchedOutline: classes.inputOutline,
            },
          }}
        />
        </div>
        <div className={classes.closeDialog}>
          <Button onClick={closeDialog} className={classes.btnClose}>
            Cancelar
          </Button>
          <Button
            onClick={copyLink}
            startIcon={linkCopy ? <DoneIcon/> : <ContentCopyIcon/> }
            className={ linkCopy ? classes.btnDisabled : classes.btnAcceptAll  }>
            { linkCopy ? 'Copiado' : 'Copiar Link' }
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
